import { defineStore } from 'pinia';

export const useStore = defineStore({
  id: 'authV2',

  state: () => {
    return {
      sapCustomerId: '',
      isTokValid: true,
      endCustomerId: '',
      tok: '',
    };
  },

  actions: {
    setEndCustomerId(id: string) {
      this.endCustomerId = id;
    },
    setSapCustomerId(id: string) {
      this.sapCustomerId = id;
    },
    setTok(token: string) {
      this.tok = token;
    },
    setIsTokValid(isTokenValid: boolean) {
      this.isTokValid = isTokenValid;
    },
  },
});
